import moment from 'moment-timezone';

export default {
  computed: {
    formattedDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : date;
    },
  },
  methods: {
    formattedCurrency(val) {
      return val
        ? val.toLocaleString('de-DE', { minimumFractionDigits: 2 })
        : '0,00';
    },
    currency(val) {
      var format = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      });
      return format.format(val);
    },
    currencyWithoutSymbol(val) {
      const formatter = new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(val);
    },
    formatAddress(address) {
      const addressData = [address.text];
      if (address.sub_district) {
        addressData.push(address.sub_district?.name || address.sub_district);
      }
      if (address.district) {
        addressData.push(address.district?.name || address.district);
      }
      if (address.city) {
        addressData.push(address.city?.name || address.city);
      }
      if (address.province) {
        addressData.push(address.province?.name || address.province);
      }
      return addressData.join(', ');
    },
    // format age for YYYY Tahun, MM Bulan, DD Hari
    ageDuration(date) {
      if (!date) return '';

      const birthDate = moment(date);
      const now = moment();

      // calculate diff year
      let years = now.diff(birthDate, 'years');
      birthDate.add(years, 'years');

      // calculate diff months
      let months = now.diff(birthDate, 'months');
      birthDate.add(months, 'months');

      // calculate diff day
      let days = now.diff(birthDate, 'days');

      const parts = [];
      if (typeof years === 'number') parts.push(`${years} Tahun`);
      if (typeof months === 'number') parts.push(`${months} Bulan`);
      if (typeof days === 'number') parts.push(`${days} Hari`);

      return parts.join(', ');
    },
  },
};
